<template lang="pug">
v-dialog.modal-package-item(:value="value", @input="$emit('input', $event)", max-width="850px")
  v-card.pa-5
    v-row
      v-col
        h2.primary--text {{ $t('modalPackageItem.selectItems') }}
      v-spacer
      g-btn(icon, @click="$emit('input', false)")
        v-icon mdi-close
    v-row
      v-col(cols="6", v-if="$getSchemaAction('Package', 'PackageProductSelector')")
        app-entity-controller-multiple(
          v-model="products",
          :entity="$findEntity('Product')",
          vertical,
        )
          template(v-slot:element="{ element, i, on: { close }}")
            g-chip(
              color="primary"
              label,
              outlined,
              close,
              close-icon="mdi-close",
              @click:close="close(element, i)",
            )
              h12.black--text {{ `${element.externalId} - ${element.name}` }}
      v-col(cols="6", v-if="$getSchemaAction('Package', 'PackageOrderLineSelector')")
        app-entity-controller-multiple(
          v-model="orderLines",
          :entity="$findEntity('OrderLine')",
          :customLoad="customLoad",
          vertical,
          :create="false",
        )
          template(v-slot:element="{ element, i, on: { close }}")
            g-chip(
              color="primary"
              label,
              outlined,
              close,
              close-icon="mdi-close",
              @click:close="close(element, i)",
            )
              h12.black--text {{ `${element.externalId}` }}
    v-card-actions
      v-spacer
      g-btn(width="130px", color="primary", @click="addItems") {{ $t('modalPackageItem.addItems') }}
      v-spacer

</template>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: ['entity', 'chips', 'invert', 'relation', 'path', 'parent', 'extraData', 'parentInstance', 'selectorOnly', 'showInfo', 'isDraft', 'isActive', 'value'],
  data: () => ({
    products: [],
    orderLines: [],
    customLoad: ['Product']
  }),
  methods: {
    addItems() {
      if ((this.toAddPackageItems.length > 0) || (this.toDeletePackageItems.length > 0)) {
        const copyInstance = _.cloneDeep(this.instance);
        const packageItemSchema = {
          _Entity: "PackageContent",
          entityState: 4,
          productId: null,
          orderLineId: null,
          extraData: [],
          package: this.parentInstance,
          quantity: 0,
          packageNo: this.parentInstance.packageNo,
          packageId: this.parentInstance.id,
        };

        const newItems = this.toAddPackageItems.map(element => ({
          ...packageItemSchema,
          ...element,
          itemNo: this.$generateUid(),
        }));

        _.forEach([...this.deletedProducts, ...this.splitedProducts], dp => {
          const index = copyInstance.findIndex(pcItem => !pcItem.orderLineId && (pcItem.productId === dp.productId));
          if (index != -1) {
            const instance = _.cloneDeep(copyInstance[index]);
            const oldState = copyInstance[index].entityState;
            if (oldState == 4) {
              copyInstance.splice(index, 1);
            } else {
              copyInstance[index].entityState = 2;
            }
            this.deletePackageContents(instance);
          }
        });

        _.forEach([...this.deletedOrderLines, ...this.splitedOrderLines], dol => {
          const index = copyInstance.findIndex(shItem => shItem.orderLineId === dol.orderLineId);
          if (index != -1) {
            const instance = _.cloneDeep(copyInstance[index]);
            const oldState = copyInstance[index].entityState;
            if (oldState == 4) {
              copyInstance.splice(index, 1);
            } else {
              copyInstance[index].entityState = 2;
            }
            this.deletePackageContents(instance);
          }
        });


        const finalShItems = [...copyInstance, ...newItems];
        this.$store.commit('SET_INSTANCE_PATH', { path: this.packageContentsPath, value: finalShItems });
        this.$emit('input', false);
      }
    },
    deletePackageContents({ itemNo }) {
      const newPackageContents = _.reduce(this.instancePackageContents, (acc, content) => {
        if (content.itemNo != itemNo) return [...acc, content];
        if (content.entityState != 4) {
          return [...acc, { ...content, entityState: 2 }];
        }

        return acc;
      }, [])
      this.$store.commit('SET_INSTANCE_PATH', { path: 'packageContents', value: newPackageContents });
    },
  },
  computed: {
    visibleInstance() {
      return (this.instance || []).filter((shItem => shItem && shItem.entityState != 2));
    },
    instanceProducts() {
      return (this.visibleInstance || []).filter(r => !r.orderLineId).map(({ product }) => ({ ...product }));
    },
    instanceOrderLines() {
      return (this.visibleInstance || []).filter(r => r.orderLineId).map(({ orderLine }) => ({ ...orderLine }));
    },
    newProducts() {
      return _.differenceBy(this.products, this.instanceProducts, 'id').map(p => ({ product: p, productId: p.id }));
    },
    newOrderLines() {
      return _.differenceBy(this.orderLines, this.instanceOrderLines, 'id').map(ol => ({ orderLine: ol, orderLineId: ol.id, productId: ol.productId, product: ol.product }));
    },
    toAddPackageItems() {
      return [...this.newProducts, ...this.newOrderLines];
    },
    deletedProducts() {
      return _.filter(this.products, p => p.entityState === 2).map(({ id }) => ({ productId: id }));
    },
    splitedProducts() {
      return _.differenceBy(this.instanceProducts, this.products, 'id').map(({ id }) => ({ productId: id }));
    },
    deletedOrderLines() {
      return _.filter(this.orderLines, oL => oL.entityState === 2).map(({ id }) => ({ orderLineId: id }));
    },
    splitedOrderLines() {
      return _.differenceBy(this.instanceOrderLines, this.orderLines, 'id').map(({ id }) => ({ orderLineId: id }));
    },
    toDeletePackageItems() {
      return [...this.deletedProducts, ...this.splitedProducts, ...this.deletedOrderLines, ...this.splitedOrderLines];
    },
    instancePackageContents() {
      return _.get(this.parentInstance, 'packageContents', []);
    },
    packageContentsPath() {
        return "packageContents";
    },
  },
  created() {
    this.products = _.cloneDeep(this.instanceProducts);
    this.orderLines = _.cloneDeep(this.instanceOrderLines);
  },
}
</script>
